import { InstagramWelcomerIcon } from '@mm/icons/StarterIcons';
import React from 'react';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { Banner } from '@mm/components';
import './ActivateIGBanner.pcss';
import InstagramIphoneIcon from './ig_comment_guard.png';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { TooltipGuard } from '../../../../../../modules/permissions/RequiresPermissions';

type Props = {
  title?: string;
};

export const BetaIgTitle = ({ title }: { title: string }) => {
  return (
    <div className="activate-ig-banner__title">
      <div>{title}</div>
    </div>
  );
};
export const ActivateIGBanner = (props: Props) => {
  const { title } = props;
  const { openInstagramConnectModal } = useModalActions();

  return (
    <Banner
      css={{ container: 'activate-ig-banner' }}
      title={
        <BetaIgTitle
          title={
            title ||
            `Create an auto response for your Instagram conversations.
              Conversations are started when user clicks the “Message” button on
              your IG account.`
          }
        />
      }
      withArrow
      button={
        <TooltipGuard>
          {isAllowed => (
            <PrimaryButton
              onClick={() => openInstagramConnectModal()} // Note: It is needed here due to types missmatch
              leftIcon={<InstagramWelcomerIcon color="#fff" />}
              color={ButtonColor.green}
              disabled={!isAllowed}
            >
              Connect Instagram
            </PrimaryButton>
          )}
        </TooltipGuard>
      }
    >
      <img
        src={InstagramIphoneIcon}
        className="c-banner__iphone-icon activate-sms-banner__phone-icon"
      />
    </Banner>
  );
};
